/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_1_VInputs */

const en_mk_proof_1_v = /** @type {(inputs: Mk_Proof_1_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One workspace`)
};

const id_mk_proof_1_v = /** @type {(inputs: Mk_Proof_1_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu ruang kerja`)
};

/**
* | output |
* | --- |
* | "One workspace" |
*
* @param {Mk_Proof_1_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_1_v = /** @type {((inputs?: Mk_Proof_1_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_1_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_1_v(inputs)
	return en_mk_proof_1_v(inputs)
});